// Messaging
const ReportsContainer = () => import("@/views/reports/containers/DefaultContainer")
const ReportsIndex = () => import("@/views/reports/views/StartingPage")
const Procedures = () => import("@/views/reports/views/Procedures")
const Attests = () => import("@/views/reports/views/Attests")
const DiagnosticReferrals = () => import("@/views/reports/views/DiagnosticReferrals")
const Referrals = () => import("@/views/reports/views/Referrals")
const ReferralYear = () => import("@/core/components/reports/referrals/ReferralYear")
const ReferralHome = () => import("@/core/components/reports/referrals/ReferralHome")
const ReferralMonth = () => import("@/core/components/reports/referrals/ReferralMonth")
const DiagnosticReferralHome = () => import("@/core/components/reports/diagnostics/DiagnosticReferralHome")
const DiagnosticReferralYear = () => import("@/core/components/reports/diagnostics/DiagnosticReferralYear")
const DiagnosticReferralMonth = () => import("@/core/components/reports/diagnostics/DiagnosticReferralMonth")
const Maternity = () => import("@/views/reports/views/Maternity")
const MaternityReportHome = () => import("@/core/components/reports/maternity/MaternityReportHome")
const Partusboek = () => import("@/views/reports/views/Partusboek")

const routes = [
    {
        path: "/reports",
        component: ReportsContainer,
        meta: {
            label: "Reports"
        },
        children: [
            {
                path: "",
                component: ReportsIndex,
                meta: {
                    roleRequired: ["physician"],
                    label: "Dashboard"
                }
            },
            {
                path: "diabetes",
                component: ReportsIndex,
                meta: {
                    roleRequired: ["physician"],
                    label: "Diabetes"
                }
            },
            {
                path: "procedures",
                component: Procedures,
                meta: {
                    roleRequired: ["physician"],
                    label: "Procedures"
                }
            },
            {
                path: "attests",
                component: Attests,
                meta: {
                    roleRequired: ["physician"],
                    label: "Attests"
                }
            },
            {
                path: "referrals",
                component: Referrals,
                meta: {
                    roleRequired: ["physician"],
                    label: "Referrals"
                },
                children: [
                    {
                        path: "",
                        component: ReferralHome,
                        meta: {
                            roleRequired: ["physician"],
                            label: "Home"
                        }
                    },
                    {
                        path: "year/:year",
                        props: true,
                        component: ReferralYear,
                        meta: {
                            roleRequired: ["physician"],
                            label: "Yearly"
                        }
                    },
                    {
                        path: "year/:year/month/:month",
                        props: true,
                        component: ReferralMonth,
                        meta: {
                            roleRequired: ["physician"],
                            label: "Monthly"
                        }
                    },
                ],
            },
            {
                path: "diagnostic-referrals",
                component: DiagnosticReferrals,
                meta: {
                    roleRequired: ["physician"],
                    label: "Diagnostic Referrals"
                },
                children: [
                    {
                        path: "",
                        component: DiagnosticReferralHome,
                        meta: {
                            roleRequired: ["physician"],
                            label: "Home"
                        }
                    },
                    {
                        path: "year/:year",
                        props: true,
                        component: DiagnosticReferralYear,
                        meta: {
                            roleRequired: ["physician"],
                            label: "Yearly"
                        }
                    },
                    {
                        path: "year/:year/month/:month",
                        props: true,
                        component: DiagnosticReferralMonth,
                        meta: {
                            roleRequired: ["physician"],
                            label: "Monthly"
                        }
                    },
                ]
            },
            {
                path: "maternity",
                component: Maternity,
                meta: {
                    roleRequired: ["physician"],
                    label: "Maternity"
                },
                children: [
                    {
                        path: "",
                        component: MaternityReportHome,
                        meta: {
                            roleRequired: ["physician"],
                            label: "Home"
                        }
                    },
                ]
            },
            {
                path: "partusboek",
                component: Partusboek,
                meta: {
                    roleRequired: ["physician"],
                    label: "Partusboek"
                }
            },
        ]
    }
]

export default routes
